import { render, staticRenderFns } from "./adminPersonalFinish.vue?vue&type=template&id=665fc3e8&scoped=true"
import script from "./adminPersonalFinish.vue?vue&type=script&lang=js"
export * from "./adminPersonalFinish.vue?vue&type=script&lang=js"
import style0 from "./adminPersonalFinish.vue?vue&type=style&index=0&id=665fc3e8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665fc3e8",
  null
  
)

export default component.exports